// extracted by mini-css-extract-plugin
export default {"wrapper":"Audios_wrapper__3G+lf","id":"Audios_id__zb75s"};